import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/Guests/GuestContacts/Get`, payload),
    GetById: (payload) => Repository.post(`/api/Guests/GuestContacts/GetById`, payload),
    Add: (payload) => Repository.post(`/api/Guests/GuestContacts/Add`, payload),
    Del: (payload) => Repository.post(`/api/Guests/GuestContacts/Del`, payload),
    SendFeedback: (payload) => Repository.post(`/api/Guests/GuestContacts/SendFeedback`, payload),
    GetByGuestID: (payload) => Repository.post(`/api/Guests/GuestContacts/GetByGuestID`, payload),
    GetByParentID: (payload) => Repository.post(`/api/Guests/GuestContacts/GetByParentID`, payload),
}
